import AddProductCategoryFormContainer from './AddProductCategoryFormContainer';

export default AddProductCategoryFormContainer;